import { ConfigProvider } from 'antd';
import 'antd/dist/reset.css';
import Body from 'body/body';
import UserContextWrapper from 'common/user-context/user-context-wrapper';
import Footer from 'footer/footer';
import Navigation from 'navigation/components/navigation';
import { ThemeProvider } from 'styled-components';
import LoginWrapper from 'ui/login-wrapper';
import { antdTheme } from 'ui/styling/antd-theme';
import 'ui/styling/global.css';
import theme from 'ui/styling/theme';

const App = () => {
  // Adding an error boundary on the highest level,
  // to catch unexpected JS errors.
  // Because this is the highest level, we put another
  return (
    <ConfigProvider theme={antdTheme}>
      <ThemeProvider theme={theme}>
        <LoginWrapper>
          <UserContextWrapper>
            <>
              <Navigation />
              <Body />
              <Footer />
            </>
          </UserContextWrapper>
        </LoginWrapper>
      </ThemeProvider>
    </ConfigProvider>
  );
};

export default App;
